import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",

    width: "520px",
    heigth: "168px",
    padding: "24px",
    paddingBottom: "0px",
    fontFamily: "Manrope !important",

    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    overflowY: "hidden",
    overflowX: "hidden",
    borderRadius: "8px",

    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
    position: "absolute",

    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },

  header: {
    width: "100%",
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    color: "#344054",
    fontFamily: "Manrope !important",
    fontSize: "20px",
    fontWeight: 800,
  },
  badge: {
    backgroundColor: "#D1E9FF",
    borderRadius: "40px",
    height: "40px",
    width: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "16px",
  },
  button: {
    cursor: "pointer",
  },

  content: {
    width: "100%",
  },
  description: {
    fontWeight: 400,
    fontSize: "16px",
    color: "#232325",
    marginBottom: "16px",
  },
  rememberMessage: {
    color: "#308CDB",
    fontStyle: "italic",
    fontWeight: 400,
    fontSize: "16px",
  },

  footer: {
    marginTop: "40px",
    backgroundColor: "#F7F7F9",
    height: "72px",
    width: "calc(100% + 80px)",
    display: "flex",
    alignItems: "center",
    padding: "0px 40px",
    justifyContent: "flex-end",
  },
}));

export default styles;
